"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const wpackio_1 = require("@lyfter/wpackio");
const select_all_and_run_1 = require("./utils/select-all-and-run");
const Menu_1 = require("./class/Menu");
const Animations_1 = require("./class/Animations");
const FixedBar_1 = require("./class/FixedBar");
const Button_1 = require("./class/Button");
const ServiceCards_1 = require("ts/class/ServiceCards");
const LocationMarkers_1 = require("ts/class/LocationMarkers");
new wpackio_1.VueApp([require.context('./components', true, /\.vue$/i), require.context('../php/Blocks', true, /\.vue$/i)], {
    el: '#page-container',
});
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) {
    document.body.classList.add('ua-safari');
}
Menu_1.Navbar.init();
Animations_1.Animations.init();
FixedBar_1.FixedBar.init();
Button_1.Button.init();
ServiceCards_1.ServiceCards.init();
LocationMarkers_1.LocationMarkers.init();
(0, select_all_and_run_1.SelectAllAndRun)('.swiper-slider', async (elements) => {
    const { Swiper } = await Promise.resolve().then(() => __importStar(require(
    /* webpackChunkName: ""swiper"" */
    /* webpackMode: "lazy-once" */
    './class/Swiper')));
    new Swiper(elements);
});
(0, select_all_and_run_1.SelectAllAndRun)('.swiper-carousel', async (elements) => {
    const { Carousel } = await Promise.resolve().then(() => __importStar(require(
    /* webpackChunkName: ""carousel"" */
    /* webpackMode: "lazy-once" */
    './class/Carousel')));
    new Carousel(elements);
});
